module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.739/images/sprocket.svg"